import { useEffect, useState } from 'react';
import { useStaffingChatStore } from 'stores/staffingChatStore';

/**
 * True once the staffing chat has been opened this session, so the popup chunk
 * stays unrequested until the user first opens the chat.
 */
export const useStaffingChatHasOpened = (): boolean => {
  const [chatHasOpened, setChatHasOpened] = useState(
    () => useStaffingChatStore.getState().isOpen
  );

  useEffect(() => {
    if (chatHasOpened) {
      return undefined;
    }
    return useStaffingChatStore.subscribe((state) => {
      if (state.isOpen) {
        setChatHasOpened(true);
      }
    });
  }, [chatHasOpened]);

  return chatHasOpened;
};
